export default function Footer() {
  return (
    <footer className="w-full">
      {/* Footer banner image */}
      <div className="w-full">
        <img
          src="https://nutravitltd.co.uk/images/footer_01.png"
          alt="Vitatec Nutrition Footer"
          className="w-full h-auto object-cover"
        />
      </div>

      {/* Bottom bar */}
      <div className="w-full bg-[#2c4a5a] py-4">
        <div className="max-w-6xl mx-auto px-6 flex items-center justify-between">
          <div>
            <p className="text-xs text-gray-300 uppercase tracking-wide">
              11 Church Road, Great Bookham, Surrey KT23 3PB — UK
            </p>
            <p className="text-xs text-gray-400 mt-0.5">Copyright &copy; 2015 Vitatec Nutrition. All rights reserved.</p>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="https://www.facebook.com/pages/Nutravit-UK-Ltd/1668634480046472"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer text-white"
            >
              <i className="ri-facebook-fill text-sm"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/nutravit-uk-ltd"
              target="_blank"
              rel="nofollow noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors cursor-pointer text-white"
            >
              <i className="ri-linkedin-fill text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
